export const rbxAuthToken = 'rbx-auth-token';
export const localizationKey = 'rbx-localization';

export const numberFormats = {
  'de-DE': {
    currency: {
      style: 'currency', currency: 'EUR',
    },
  },
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD',
    },
  },
  'tr-TR': {
    currency: {
      style: 'currency', currency: 'TRY',
    },
  },
};

export const dateFormats = {};
